import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import introImg from '../assets/newHeader/education1.jpeg';
import image1 from '../assets/newHeader/education5.jpeg';
import image2 from '../assets/newHeader/education6.jpeg';
import image3 from '../assets/newHeader/education7.jpeg';
import image31 from '../assets/newHeader/education8.jpeg';
import image32 from '../assets/newHeader/education9.jpeg';
import drivingChanges from '../assets/public-site/drivingChanges.png';
import { ReactComponent as CaptureIcon } from '../assets/public-site/education1.svg';
import { ReactComponent as BuildIcon } from '../assets/public-site/education2.svg';
import { ReactComponent as TrackIcon } from '../assets/public-site/education3.svg';
import ellipseEducation from '../assets/public-site/ellipseEducation.png';
import connectingLine from '../assets/public-site/hiw-connectingLine.svg';
import schoolImage1 from '../assets/public-site/schoolImage1.png';
import stackImage1 from '../assets/public-site/workImage.png';
import workImage1 from '../assets/public-site/workImage1.png';
import { FeatureCard } from '../components/common/FeatureCard';
// import { InfoCard } from '../components/common/InfoCard';
// eslint-disable-next-line import/order
import { ExportedIcon } from '../components/icons/icons';
import { NewFooter } from '../components/Layout/NewFooter';
import { NewNavbar } from '../components/Layout/NewHeader';

import { ConnectForm } from './ConnectUseForm';

export const EducationPage: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const features = [
    {
      image: image1,
      title: 'Quantify Overlooked Potential',
      description:
        'We capture nontraditional strengths-like motivation, executive functioning, and real-world experience-through structured assessments built for early-career learners. These overlooked indicators often predict long-term success better than grades or test scores.',
    },
    {
      image: image2,
      title: 'Aggregate + Amplify What You Already Have',
      description:
        'We integrate data across your LMS, SIS, CTE programs, WBL hours, and co-curricular inputs-transforming siloed systems into a cohesive career readiness profile.',
    },
    {
      image: image3,
      title: 'Career Fit, Grounded in Real Employer Needs',
      description:
        ' We help students discover which industries and roles are the best fit for their strengths—based on hiring patterns, employer input, and real-world success signals. Whether they’re exploring healthcare, logistics, retail, or manufacturing, we guide them toward first steps that lead to long-term growth.',
    },
    {
      image: image31,
      title: 'Smarter Matching, Better Outcomes',
      description:
        'Once students know where they fit, we connect them to real-world opportunities. Our platform uses performance data, employer feedback, and predictive modeling to place students in internships or jobs where they’re most likely to succeed—not just where there’s an opening.',
    },
    {
      image: image32,
      title: 'Fast Setup, Long-Term Value',
      description:
        'No rip-and-replace. Vero works within your existing infrastructure, supports your staffing model, and aligns with your reporting requirements—making it easy to get started and scale as you grow.',
    },
  ];

  return (
    <div>
      <NewNavbar />
      {/* container 1 */}
      <section>
        <div className="relative w-full h-screen overflow-hidden">
          {/* Background image */}
          <img
            src={introImg}
            alt="Intro Image"
            className="absolute top-0 left-0 w-full h-full object-cover z-0"
          />

          {/* Overlay */}
          <div className="absolute inset-0 bg-black bg-opacity-30 z-10"></div>

          {/* Content at the bottom center */}
        </div>
      </section>
      {/* Workforce Section */}
      <section className="py-16">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight lg:!leading-[83px] mb-5">
            From the classroom to the
            <span className="font-bold text-primary-500">
              {' '}
              workforce- <span className="lg:block">with clarity.</span>{' '}
            </span>
          </h2>
        </div>
        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mt-12">
            {/* Left Content */}
            <div className="mx-auto md:mt-10 items-center gap-10">
              {/* Left Column - Text */}
              <div className="text-center md:text-left space-y-6">
                {[
                  {
                    desc: `Vero Learning helps schools move beyond course completion to actual career-connected outcomes. 
                    We quantify potential-not just transcripts-and align students with real-world opportunities using 
                    predictive profiles built on lived experience, durable skills, and employment readiness signals.`,
                  },
                  {
                    desc: `We’re not a curriculum or LMS. We’re the connective layer that pulls data across your 
                    systems-making it usable, personalized, and outcome-focused.`,
                  },
                  {
                    desc: `Already trusted by over 35,000 students with a 92% completion rate (with no teacher prompting), 
                    Vero delivers results without adding complexity.`,
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="border-dashed border border-purple-200 rounded-[32px] p-7"
                  >
                    <p className="text-black text-xl font-medium leading-[36px] ">{item.desc}</p>
                  </div>
                ))}
              </div>
              <div className="flex justify-center lg:justify-start">
                <a
                  href="https://meetings.hubspot.com/chrissybil/vero-learning"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-6 btn btn-secondary !whitespace-normal !py-6 !px-8"
                >
                  Schedule a Strategy Session <ExportedIcon />
                </a>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative w-full flex items-center justify-center">
              <img
                src={workImage1}
                alt="Work Image"
                className="w-full 2xl:w-3/4 h-auto object-contain rounded-xl"
              />
            </div>
          </div>
        </div>
      </section>
      {/* Stack Section*/}
      <section className="py-16 pt-4">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight lg:!leading-[75px] mb-5">
            What’s at
            <span className="font-bold text-primary-500"> Stake</span>
          </h2>
          <p className="text-xl sm:text-2xl md:text-3xl !leading-relaxed">
            You’re preparing students for the future-but the handoff to employment is broken.
          </p>
        </div>
        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mt-12">
            {/* Left Content */}
            <div className="mx-auto md:mt-10 items-center gap-10">
              {/* Left Column - Text */}
              <div className="text-center md:text-left space-y-6">
                {[
                  {
                    list: [
                      'Employers still can´t see beyond course completions, grades, or formal work experience.',
                      'Work-based learning doesn’t always lead to real roles',
                      'Students complete programs but lack visibility into fit',
                      'School systems have little data on placement success',
                      'Talent potential is missed because the system wasn’t designed to catch it',
                    ],
                  },
                ].map((item, index) => (
                  <div key={index} className="rounded-[32px] p-7 bg-green-200">
                    {item.list && (
                      <ul className="text-black text-xl list-disc list-outside font-medium leading-relaxed lg:leading-[40px] pl-5 text-left">
                        {item.list.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
              <div className=" py-7">
                <p className="text-black font-normal text-2xl leading-[40px] text-center lg:text-left">
                  Vero helps you prove outcomes, not just pathways. We close the loop between
                  learning and long-term employment—especially for students with the most to gain.
                </p>
              </div>
            </div>
            {/* Right Image */}
            <div className="relative w-full flex items-center justify-center">
              <img
                src={stackImage1}
                alt="stack Image"
                className="w-full 2xl:w-3/4 h-auto object-contain rounded-xl"
              />
            </div>
          </div>
        </div>
        <div className="container flex flex-col lg:flex-row items-center justify-between gap-4 py-10">
          <h2 className="font-bold text-3xl leading-[54px] align-middle text-center lg:text-left">
            Give employers visibility into your students’ potential.
          </h2>

          <a
            href="https://meetings.hubspot.com/chrissybil/vero-learning"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-secondary !px-12 !py-6 hover:underline !whitespace-normal"
          >
            Map skills to roles - before graduation <ExportedIcon />
          </a>
        </div>
      </section>
      {/* What You Get Section */}
      <section className="py-16 bg-primary-200">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight lg:!leading-[75px] mb-10">
            What You
            <span className="font-bold text-primary-500"> Get</span>
          </h2>
        </div>
        <div className="container">
          <div className="w-full flex justify-center">
            <div className="px-4 w-full space-y-6">
              {/* First row - 3 cards */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 place-items-stretch">
                {features.slice(0, 3).map((feature, index) => (
                  <FeatureCard
                    key={index}
                    image={feature.image}
                    title={feature.title}
                    description={feature.description}
                  />
                ))}
              </div>

              {/* Second row - 2 cards centered */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 place-items-stretch lg:justify-center">
                {features.slice(3).map((feature, index) => (
                  <FeatureCard
                    key={index + 3}
                    image={feature.image}
                    title={feature.title}
                    description={feature.description}
                  />
                ))}
              </div>
            </div>
          </div>
          <p className="text-xl md:text-3xl !leading-relaxed text-center mt-8">
            Access aggregate reporting to inform funding decisions, strengthen grant proposals, and
            personalize support while tracking individual student growth in real time.
          </p>
          {/* Button Section */}
          <div className="flex flex-col sm:flex-row gap-4 items-center justify-center mt-8 text-center">
            <a
              className="btn btn-secondary !py-6 !px-12"
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              target="_blank"
              rel="noopener noreferrer"
            >
              Connect with our team <ExportedIcon />
            </a>
          </div>
        </div>
      </section>
      {/* How It Works Section  */}
      <section className="pt-16">
        <div className="container">
          <div className="text-center mb-10">
            <h2 className="text-3xl sm:text-4xl md:text-6xl !leading-snug mb-6">
              How It
              <span className="text-primary-500 font-bold"> Works</span>
            </h2>
            <p className="text-3xl">
              Vero integrates with your existing student success systems—no new tech lift required.
            </p>
          </div>

          {/* Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {/* Step 1 */}
            <div className="relative bg-primary-100 rounded-[40px] p-8 flex flex-col items-center text-center max-h-[450px]">
              <CaptureIcon className="mb-5" />
              <h3 className="text-xl font-semibold mb-3">Capture Student Experience</h3>
              <p className="text-lg ">
                Structured intake captures lived experience, transferable skills, and pre-employment
                readiness-not just grades or aspirations.
              </p>
            </div>

            {/* Step 2 */}
            <div className="relative md:mt-[15%]">
              <img
                src={connectingLine}
                alt="connecting Line"
                className="relative -ml-10 hidden md:block"
              />
              <div className="bg-primary-100 rounded-[40px] p-8 flex flex-col items-center text-center max-h-[450px]">
                <BuildIcon className="mb-5" />
                <h3 className="text-xl font-semibold mb-3">Build Profiles + Pathways</h3>
                <p className="text-lg ">
                  AI-powered learner profiles scored against industry-aligned competencies generate
                  pathway recommendations based on real hiring data.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="relative md:mt-[50%]">
              <img
                src={connectingLine}
                alt="connecting Line"
                className="relative -ml-10  hidden md:block"
              />
              <div className="bg-primary-100 rounded-[40px] p-8 flex flex-col items-center text-center max-h-[450px]">
                <TrackIcon className="mb-5" />
                <h3 className="text-xl font-semibold mb-3">Track Growth On + Off Platform</h3>
                <p className="text-lg ">
                  Through API and offline integration, we track progress across coursework,
                  internships, enrichment programs, and beyond—keeping students and educators
                  aligned.
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row items-center justify-between gap-4 py-10">
            <h2 className="font-bold text-3xl leading-[54px] align-middle text-center md:text-left">
              Built for scale. Designed for privacy. Ready to integrate.
            </h2>

            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary !px-12 !py-6 hover:underline !whitespace-normal"
            >
              Want to see it in action?
              <ExportedIcon />
            </a>
          </div>
        </div>
      </section>
      {/* Built for School Systems Section */}
      <section className="pb-16">
        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-[35%_65%] gap-10 items-center mt-12">
            {/* Left Image */}
            <div className="relative w-full flex items-center justify-center">
              <img
                src={drivingChanges}
                alt="driving Changes"
                className="w-full 2xl:w-3/4 h-auto object-contain rounded-xl"
              />
            </div>
            {/* Right Content */}
            <div className="mx-auto md:mt-10 items-center gap-10">
              {/* Right Column - Text */}
              <div className="mx-auto text-center lg:text-left">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight lg:!leading-[75px] mb-5">
                  Built for School Systems
                  <span className="font-bold text-primary-500 block"> Driving Change</span>
                </h2>
              </div>
              <div className="text-center md:text-left space-y-6">
                {[
                  {
                    list: [
                      'Community colleges and dual enrollment programs',
                      'K–12 districts focused on workforce readiness and job placement',
                      'CTE, reentry, and alternative education pathways',
                      'Guidance counselors, WBL teams, and district leadership',
                    ],
                  },
                ].map((item, index) => (
                  <div key={index} className="mt-4">
                    {item.list && (
                      <ul className="text-black mt-4 text-xl list-disc list-outside font-normal leading-loose pl-5 text-left">
                        {item.list.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
              <div className="py-7">
                <p className="text-black font-normal text-lg leading-[40px] text-center lg:text-left">
                  Vero helps counselors and CTE leads track career readiness over time—not just
                  course completion. You’ll get visibility into strengths, gaps, and best-fit
                  pathways, so no student gets left behind.
                </p>
              </div>
              <div className="m-auto items-center">
                <p className="text-black font-normal text-2xl leading-[25px] mb-4 text-left mt-7">
                  Access real-time data that help district leaders advocate for funding, align
                  curriculum with employer needs, and measure impact
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Yellow Section */}
      <section className="py-8 bg-green-200">
        <div className="container">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div>
              <p className="text-2xl text-center lg:text-left">
                We work hand-in-hand with school-based teams to support scalable career
                readiness—without adding platform fatigue or operational burden.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Why School Leaders Section */}
      <section className="pt-16 bg-primary-200 relative overflow-hidden">
        <div className="absolute top-[-4rem] lg:left-[-4rem]">
          <img src={ellipseEducation} alt="ellipse Educatione" className="object-contain" />
        </div>

        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-[40%_60%] gap-10 items-end">
            {/* Left Image */}
            <div className="relative w-full flex items-end justify-center">
              <img
                src={schoolImage1}
                alt="School Image"
                className="w-full 2xl:w-3/4 h-auto object-contain rounded-xl"
              />
            </div>
            {/* Right Content */}
            <div className="mx-auto md:mt-10 items-center gap-10 pb-10">
              {/* Right Column - Text */}
              <div className="mx-auto text-center lg:text-left">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight lg:!leading-[75px] mb-5">
                  Why School Leaders
                  <span className="font-bold text-primary-500 block"> Choose Vero</span>
                </h2>
              </div>
              <div className="text-center md:text-left space-y-6">
                {[
                  {
                    desc: `We make sure no student’s potential is overlooked just because it doesn’t show up on a transcript.`,
                    list: [
                      'Over 35,000 students onboarded',
                      '87% student completion rate —without needing teacher prompting',
                      'FERPA & COPPA compliant from day one',
                      'Customizable by school, program, or region',
                      'Built with input from educators, employers, and students',
                    ],
                  },
                ].map((item, index) => (
                  <div key={index} className="">
                    <p className="text-black text-xl">{item.desc}</p>
                    {item.list && (
                      <ul className="text-black mt-4 text-xl list-disc list-outside font-normal leading-loose lg:leading-loose pl-5 text-left">
                        {item.list.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
              <div className="py-5">
                <p className="text-black font-normal text-xl leading-[40px] text-center lg:text-left">
                  With Vero, students aren’t just matched once—they’re supported over time. Our
                  platform evolves with them, tracking performance and refining guidance based on
                  real-world outcomes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* container 13 */}
      <ConnectForm
        header="Let’s Connect the Dots"
        text="Vero helps you integrate what you already have, elevate student voice, and drive workforce-aligned outcomes across your schools. No new curriculum. No added complexity. Just smarter systems that work."
        buttonText="Book a Strategy Session"
      />
      <NewFooter />
    </div>
  );
};
